import { useCallback } from 'react'
import { SendField } from '$comp/_app/components/chat/components/footer/components/send-field'
import { ActionButton } from '$comp/_app/components/chat/components/footer/components/action-button'
import { showLeaveHallModal } from '$comp/modals/confirmation-dialog'
import { useOpenedRoomPermissions } from '$logic/opened-room'
import { joinHall, setSubscriptionMute } from '$logic/subscription'
import { useSubscription } from '$logic/subscription/react-hook'
import { useHall } from '$logic/hall/react-hook'
import { isClientsRoom } from '$logic/room'
import { t } from '$i18n'

export function HallFooter({
  roomId,
  isGroup,
}: {
  roomId: string
  isGroup: boolean
}) {
  const { entity: hall, loading: hallLoading } = useHall(roomId)
  const {
    entity: subscription,
    loading: subscriptionLoading,
  } = useSubscription(roomId)

  const { openedRoomPermissions } = useOpenedRoomPermissions()
  const { sendMessage } = openedRoomPermissions || {}
  const subscribed = isClientsRoom(roomId)

  const onNotificationClick = useCallback(async () => {
    await setSubscriptionMute(roomId, !subscription?.muted)
  }, [roomId, subscription?.muted])

  const onJoinClick = useCallback(async () => {
    analite('CHAT_JOIN', { source: 'HALL_FOOTER', name: hall?.identifier })
    await joinHall(roomId)
  }, [roomId, hall?.identifier])

  const onLeave = useCallback(async () => {
    await showLeaveHallModal(roomId)
  }, [roomId])

  if (hallLoading || (subscribed && subscriptionLoading)) return null

  return hall?.deletedAt ? (
    <ActionButton
      text={isGroup ? t('menu.hall.leaveGroup') : t('menu.hall.leaveChannel')}
      onClick={onLeave}
    />
  ) : !subscribed ? (
    <ActionButton
      text={
        isGroup
          ? t('profile.hall.actions.joinGroup')
          : t('profile.hall.actions.joinChannel')
      }
      onClick={onJoinClick}
    />
  ) : !sendMessage ? (
    <ActionButton
      text={subscription?.muted ? t('chat.unMute') : t('chat.mute')}
      onClick={onNotificationClick}
    />
  ) : (
    <SendField roomId={roomId} />
  )
}
